import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Area, JobIssue } from "../../../../core/database/db";

export type AreaWithIssues = Pick<Area, "id" | "name"> & { issues: JobIssue[] };

export interface ViewIssueEvent {
  area: AreaWithIssues;
  issue: JobIssue;
}

@Component({
  selector: "app-area-issues-list",
  standalone: true,
  templateUrl: "./area-issues-list.component.html",
  styleUrl: "./area-issues-list.component.scss"
})
export class AreaIssuesListComponent {
  @Input() areasWithIssues: AreaWithIssues[] = [];
  @Input() getViewIssuesUrl: (area: AreaWithIssues, issue: JobIssue) => string;
  @Input() issuesSavingMap: Record<string, boolean> = {};
  @Output() onViewIssue = new EventEmitter<ViewIssueEvent>();

  getIssueLink(area: AreaWithIssues, issue: JobIssue): string {
    return this.getViewIssuesUrl(area, issue);
  }

  viewIssue(area: AreaWithIssues, issue: JobIssue, event: Event): void {
    event.preventDefault();

    this.onViewIssue.emit({ area, issue });
  }
}
